import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import { createViewEdit, formatDateTime } from "../../utils/helpers";
import { URL_FRAUD_EVENTS } from "../../utils/urls";

const url = URL_FRAUD_EVENTS;

export const useFraudEvents = () => {
  const tableColumns = () => [
    { id: "event_id", header: "Event ID", filter: { type: "text" } },
    { id: "event_type", header: "Event Type", filter: { type: "text" } },
    { id: "user_info", header: "User Info", filter: { type: "text" } },
    {
      id: "transaction_reference",
      header: "Transaction Reference",
      filter: { type: "text" },
    },
    { id: "fraud_score", header: "Fraud Score", filter: { type: "number" } },
    { id: "risk_level", header: "Risk Level", filter: { type: "text" } },
    {
      id: "triggered_rules_count",
      header: "Triggered Rules Count",
      filter: { type: "number" },
    },
    { id: "location_name", header: "Location Name", filter: { type: "text" } },
    { id: "is_blocked", header: "Is Blocked", filter: { type: "boolean" } },
    { id: "action_taken", header: "Action Taken", filter: { type: "text" } },
    { id: "is_reviewed", header: "Is Reviewed", filter: { type: "boolean" } },
    {
      id: "event_timestamp",
      header: "Event Timestamp",
      filter: { type: "date" },
    },
    { id: "detected_at", header: "Detected At", filter: { type: "date" } },
    { id: "created_by", header: "Created By", filter: { type: "text" } },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        event_timestamp: formatDateTime(item?.event_timestamp),
        detected_at: formatDateTime(item?.detected_at),
        user_info: item?.user_info?.username,
        created_by:
          item?.created_by?.first_name + " " + item?.created_by?.last_name,
        is_blocked: <BooleanTags status={item?.is_blocked} />,
        is_reviewed: <BooleanTags status={item?.is_reviewed} />,
        action_taken: item?.action_taken || "No action taken",
        risk_level: item?.risk_level || "No risk level",
        actions: (
          <FormActions actions={[...createViewEdit(url, item?.id, true)]} />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: {
              message: "No data available",
            },
          },
        ],
      };
    }
    return {
      sections: [
        {
          title: "Fraud Event Details",
          fields: {
            event_id: item?.event_id,
            event_type: item?.event_type,
            user_info: item?.user_info?.username,
            transaction_reference: item?.transaction_reference,
            fraud_score: item?.fraud_score,
            risk_level: item?.risk_level,
            triggered_rules_count: item?.triggered_rules_count,
            location_name: item?.location_name,
            is_blocked: <BooleanTags status={item?.is_blocked} />,
            action_taken: item?.action_taken,
            is_reviewed: <BooleanTags status={item?.is_reviewed} />,
            event_timestamp: formatDateTime(item?.event_timestamp),
            detected_at: formatDateTime(item?.detected_at),
            created_by:
              item?.created_by?.first_name + " " + item?.created_by?.last_name,
          },
        },
      ],
    };
  };

  return {
    tableColumns,
    tableData,
    viewData,
  };
};
